import {basicFormat, currencyFormat} from "../utils";


type SingleValueProps = {
    format: string | undefined;
    value: any;
    groupBy: string;
}
const SingleValue = ({format, value, groupBy}: SingleValueProps) => {
    return (
        <div className="responsiveBar__container">

            <div className={'singleValue'}>
                <div className={'value'}>
                    {format === 'currency' ? currencyFormat(value['value']) : basicFormat(value['value'])}
                </div>
                <div className={'value-desc'}>
                    {groupBy && value && value[groupBy] && value[groupBy].toString()}
                </div>
            </div>
        </div>
    )
}

export {SingleValue}